import { render, staticRenderFns } from "./ProfileDefaultApp.vue?vue&type=template&id=3ac36f4a&scoped=true&"
import script from "./ProfileDefaultApp.vue?vue&type=script&lang=js&"
export * from "./ProfileDefaultApp.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDefaultApp.vue?vue&type=style&index=0&id=3ac36f4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac36f4a",
  null
  
)

export default component.exports